import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Typography, Spin } from 'antd';
import Navbar from './Navbar';
import Footer from '../component/Footer';
import SafeImage from '../component/SafeImage';
import { useCategory } from '../context/CategoryContext';
import { usePreference } from '../context/PreferenceContext';

const { Title, Text } = Typography;

const CategoriesScreen = () => {
    const { t } = usePreference();
    const navigate = useNavigate();
    const { parentCategories: categories, loading } = useCategory();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: '80px' }}>
            <Navbar />
            <div className="standard-page-container pcu-padding-x-16 pcu-padding-y-24">
                <Title level={3} style={{ marginBottom: 24, textAlign: 'center' }}>{t('categories') || 'All Categories'}</Title>
                
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}><Spin size="large" /></div>
                ) : (
                    <Row gutter={[16, 16]}>
                        {categories.map((cat) => (
                            <Col xs={8} sm={6} md={4} key={cat._id || cat.id}>
                                <div 
                                    onClick={() => navigate(`/category/${cat.name}?categoryId=${cat._id || cat.id}`)}
                                    style={{ 
                                        background: 'white', 
                                        borderRadius: '12px', 
                                        padding: '16px 8px', 
                                        textAlign: 'center',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                        cursor: 'pointer',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <div style={{ 
                                        width: '60px', 
                                        height: '60px', 
                                        borderRadius: '50%', 
                                        background: '#f1f5f9',
                                        marginBottom: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden'
                                    }}>
                                        <SafeImage 
                                            src={cat.imageUrl || cat.image} 
                                            alt={cat.name} 
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                    <Text strong style={{ fontSize: '12px', lineHeight: '1.2' }}>
                                        {cat.name}
                                    </Text>
                                </div>
                            </Col>
                        ))}
                    </Row>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default CategoriesScreen;
